import { Container } from "@ster/ster-toolkit";
import { Grid } from "antd";
import classNames from "classnames";
import { PropsWithChildren } from "react";

import styles from "./TipSlide.module.less";

const { useBreakpoint } = Grid;

interface TipSlideProps {
  image?: string;
  className?: string;
}

const TipSlide = ({
  image,
  className,
  children,
}: PropsWithChildren<TipSlideProps>) => {
  const screens = useBreakpoint();
  const wide = screens.sm && !screens.lg;

  return (
    <Container className={classNames(styles.tip, className)}>
      {image && (
        <div className={styles.image}>
          {wide ? (
            <img
              src={`${image}&mode=crop&width=800&height=200&quality=75`}
              alt="Logo"
            />
          ) : (
            <img
              src={`${image}&mode=crop&width=352&height=140&quality=75`}
              alt="Logo"
            />
          )}
        </div>
      )}

      <div className={styles.text}>{children}</div>
    </Container>
  );
};

export default TipSlide;
